// src/components/AchievementUnlockedModal.jsx
import React, { useEffect, useState } from "react";
import ReactDOM from "react-dom"; // ✅ portal
import { doc, onSnapshot } from "firebase/firestore";
import { db, auth } from "../firebase";
import achievementsData from "../data/achievementsData";
import "./AchievementUnlockedModal.css";

export default function AchievementUnlockedModal() {
  const [queue, setQueue] = useState([]);
  const [current, setCurrent] = useState(null);
  const [showModal, setShowModal] = useState(false);
  const [fade, setFade] = useState(false);

  // Listen to userAchievementClaimed
  useEffect(() => {
    const userId = auth.currentUser?.uid;
    if (!userId) return;

    const userDocRef = doc(db, "Users", userId);

    const unsubscribe = onSnapshot(userDocRef, (snapshot) => {
      const data = snapshot.data();
      const claimed = data?.userAchievementClaimed;

      if (claimed && claimed.toLowerCase() !== "none") {
        const achievementsArray = claimed
          .split(",")
          .map((a) => a.trim().toLowerCase())
          .filter((a) => a);

        // prevent duplicate spam
        setQueue((prevQueue) => {
          const newOnes = achievementsArray.filter((a) => !prevQueue.includes(a));
          return [...prevQueue, ...newOnes];
        });
      }
    });

    return () => unsubscribe();
  }, []);

  // Show next achievement
  useEffect(() => {
    if (!current && queue.length > 0) {
      const next = queue[0];
      setCurrent(next);
      setQueue((prev) => prev.slice(1));
      setShowModal(true);
      setFade(true);
    } else if (!current && queue.length === 0) {
      setShowModal(false);
    }
  }, [queue, current]);

  // Continue button
  const handleContinue = async () => {
    setFade(false);

    setTimeout(async () => {
      if (queue.length > 0) {
        const next = queue[0];
        setCurrent(next);
        setQueue((prev) => prev.slice(1));
        setFade(true);
      } else {
        setCurrent(null);
        setShowModal(false);

        try {
          const token = await auth.currentUser.getIdToken(true);
          await fetch("https://resetachievement-5dhfwyjvzq-uc.a.run.app", {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
              Authorization: `Bearer ${token}`,
            },
            body: JSON.stringify({}),
          });
        } catch (err) {
          console.error("Failed to reset achievement:", err);
        }
      }
    }, 300);
  };

  if (!showModal || !current) return null;

  const achievement =
    achievementsData[current] || { name: current, description: "" };

  return ReactDOM.createPortal(
    <div className="achievement-modal-overlay">
      <div
        className={`achievement-modal-container ${
          fade ? "fade-in" : "fade-out"
        }`}
      >
        <div className="achievement-modal-title">
          Achievement Unlocked!
        </div>

        <div className="achievement-modal-content">
          <h3>{achievement.name}</h3>
          <p>{achievement.description}</p>
        </div>

        <div className="achievement-modal-actions">
          <button className="settings-button" onClick={handleContinue}>
            Continue
          </button>
        </div>
      </div>
    </div>,
    document.body
  );
}